import React from 'react'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import { withStyles } from '@material-ui/core/styles'

const styles = (theme) => ({
	root: {
		width: '50%',
		marginRight: 0,
		paddingRight: theme.spacing.unit * 2,
		boxSizing: "border-box",
	}
})

const FieldCheckbox = ({ checked, onChange, field, label, disabled, classes }) => (
	<FormControlLabel
        control = { <Checkbox checked={checked} onChange={onChange} value={field} key={field} disabled={disabled} /> }
        label = {label}
        className = {classes.root}
    />
)

export default withStyles(styles)(FieldCheckbox)



// WEBPACK FOOTER //
// ./src/components/Export/FieldCheckbox.js